// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8596db301f22f71e138e","883":"4157e2bb5f00dc82be95"}[chunkId] + ".js";
};